import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


class HistoryGrid extends Component {
  

  // Constructor initiate callback methods and sets initial state
  constructor(props) {
    super(props);  
    this.data = props.data;
    this.data.Service.GetAccountManagementHistoryListCallback = this.fillList.bind(this);
    
    // Keep state in current state because the state can be changed only once per event.
    this.currentState = {
        rows:[]
    }

    // Set state
    this.state = {...this.currentState}
  }

  fillList(list){
    let newRows = []
    for(let index = 0; index < list.length; index++){
      newRows.push(this.createData("row" + index, list[index].Date, list[index].Representative, list[index].Description));
    }

    // Set state
    this.setState({rows:newRows});

    this.data.AccountManagement.SetCount(list.length);
  }

    
    createData(key, name, calories, fat) {
        return {key, name, calories, fat };
    }
    
      classes = {
        root: {
          width: '100%',
          marginTop: "20px",
          overflowX: 'auto',
        },
       
    }

  /// Render html
  render() {
   
    return (
    <Table className={this.classes.table}>
        <TableHead style={{display:"block"}}>
          <TableRow>
            <TableCell style={{width:"200px"}}>Date</TableCell>
            <TableCell style={{width:"200px"}} align="left">Representative</TableCell>
            <TableCell style={{width:"450px"}} align="left">Description</TableCell>
          </TableRow>
        </TableHead>
        <TableBody style={{height:"200px",display:"block",overflowY:"auto"}}>
          {this.state.rows.map(row => (
            <TableRow key={row.key}>
              <TableCell style={{width:"200px"}} component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell style={{width:"200px"}} align="left">{row.calories}</TableCell>
              <TableCell style={{width:"450px"}} align="left">{row.fat}</TableCell>
              
            </TableRow>
          ))}
        </TableBody>
    </Table>
    );
  }
}

export default HistoryGrid;